import { ImgText } from '../../shared/utils/Heading'
import { LinearGradientText } from './Layout'
import TabsComponent from '../../shared/components/Tabs/TabComponent';
import TabPanel from '../../shared/components/Tabs/TabPanel';
import useTabs from '../../shared/hook/useTabs';
import { Box } from '@mui/material';
import { Constants } from '../../shared/constants';
import { Link } from 'react-router-dom';
import EmployeeLoginForm from './EmployeeLoginForm';

const tabsData = [
    {
        label: "Login", component: <EmployeeLoginForm/>
    },
  
];

const EmployeeSmallScreen = ({ tabPage }) => {
    const { value, handleChange } = useTabs(tabPage);
    return (
        <Box padding={"20px"}>

            <Box mb={2} >
                <Link to={'/'}><img src={Constants.customImages.Logo} alt="logo" width={"100px"} height={"auto"} /></Link>
                <Box mb={4} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <ImgText text={"Welcome!!"} sx={{ textAlign: "center" }} />
                    <LinearGradientText
                        text={
                            value === 0
                                ? "Employee login to continue your work journey."
                                : "Employee login to continue your work journey."
                        }
                    />

                </Box>
                <Box>
                    <TabsComponent tabs={tabsData} value={value} onChange={handleChange} />
                    {tabsData.map((tab, index) => (
                        <TabPanel key={index} value={value} index={index}>
                            {tab.component}
                        </TabPanel>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default EmployeeSmallScreen














